import onConversationOptionSaved from "owa-options-actions/lib/onConversationOptionSaved";
import onWin32StyleEnabledChanged from "owa-theme-win32-style-store/lib/actions/onWin32StyleEnabledChanged";
import { orchestrator } from "satcheljs";
import updateWin32StyleReadingPaneViewPreview from "../mutators/updateWin32StyleReadingPaneViewPreview";
import getReadingPaneViewType from "../selectors/getReadingPaneViewType";
import getStore from "../store/store";

orchestrator(onWin32StyleEnabledChanged, ({ isEnabled }) => {
    const hasRememberedNonWin32StyleValue = getStore().nonWin32StyleReadingPaneViewType !== null;
    
    if (!isEnabled && !hasRememberedNonWin32StyleValue) {
        return;
    }
    
    updateWin32StyleReadingPaneViewPreview(isEnabled, getReadingPaneViewType());
    onConversationOptionSaved();
});
